import ContactUsBlock from "../components/ContactUsBlock";
import {Helmet} from "react-helmet";

const Contacts  = () => {
  return (
    <div>
      <Helmet>
        <title>Gordito Plus - Компанія Bestfruver SL</title>
        <meta
          name="contacts"
          content="Компанія Bestfruver SL зареєстрована і веде свою основну діяльність в Іспанії. Основним напрямком розвитку являються експорт та імпорт продуктів харчування, спеціалізація гуртові постачання."
        />
        <meta
          name="title"
          content="Компанія Bestfruver SL зареєстрована і веде свою основну діяльність в Іспанії. Основним напрямком розвитку являються експорт та імпорт продуктів харчування, спеціалізація гуртові постачання."
        />
      </Helmet>
     <ContactUsBlock />
    </div>
  )
}

export default Contacts


